// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1SOQ-","header":"ReportDetails_header__3UMtP","title":"ReportDetails_title__Y-B1J","left":"ReportDetails_left__2W9CO"};